// Get full image URL from stored path
export const getImageUrl = (path) => {
    if (!path) return null;
    
    // 1. If it's already a full URL (Cloudinary or external)
    if (path.startsWith('http://') || path.startsWith('https://') || path.startsWith('data:')) {
        // OPTIMIZATION: If using Cloudinary, inject auto-format and auto-quality
        if (path.includes('cloudinary.com')) {
            return path.replace('/upload/', '/upload/f_auto,q_auto,w_1200,c_limit/');
        }
        return path;
    }

    // 2. Handle public folder images
    if (path.startsWith('/images/')) return path; 

    // 3. Local Backend fallback (for development)
    const baseUrl = (process.env.REACT_APP_API_URL || 'http://localhost:5000/api').replace('/api', '');
    const normalizedPath = path.replace(/\\/g, '/');
    return `${baseUrl}/${normalizedPath}`;
};

// Format date efficiently
export const formatDate = (date) => {
    if (!date) return '';
    return new Date(date).toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'long',
        day: 'numeric'
    });
};

// Truncate text (Reduces DOM weight in lists)
export const truncateText = (text, maxLength = 100) => {
    if (!text) return '';
    if (text.length <= maxLength) return text;
    return text.substring(0, maxLength) + '...';
};

// Parse stats (for animations)
export const parseStatValue = (value) => {
    if (!value) return { number: 0, suffix: '' };
    const str = String(value);
    const match = str.match(/^([\d,]+)(.*)/);
    if (match) {
        return { number: parseInt(match[1].replace(/,/g, '')), suffix: match[2] };
    }
    return { number: 0, suffix: str };
};